module.exports = __webpack_public_path__ + "img/product-atomizer-sopuria-SUBOX.1b2cadb4.jpg";